// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"History__Wrapper_3r3jp","Inner":"History__Inner_2kIVq grid","Description":"History__Description_1Z8BN"};